import React from "react";
import PropTypes from "prop-types";

import { Glyph } from "./style";
import "./_glyphicons.scss";

export const Glyphicon = ({ name }) => {
  return <Glyph className={`glyphicon glyphicon-${name}`} />;
};

Glyphicon.propTypes = {
  name: PropTypes.string,
};
